module.exports = {
      id: "cdccde686e8f4e4188ba3255bae1ae8bstate-new.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#cdccde686e8f4e4188ba3255bae1ae8bstate-new.svg",
      toString: function () {
        return this.url;
      }
    }